/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var filters;
    (function (filters) {
        var BreezeDeleted = /** @class */ (function () {
            function BreezeDeleted() {
            }
            BreezeDeleted.prototype.filter = function (input) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (input == undefined)
                    return undefined;
                var x = input.filter(function (item) {
                    return !item.entityAspect.entityState.isDeleted();
                });
                return x;
            };
            return BreezeDeleted;
        }());
        filters.BreezeDeleted = BreezeDeleted;
    })(filters = warsApp.filters || (warsApp.filters = {}));
})(warsApp || (warsApp = {}));
warsApp.registerFilter('BreezeDeleted');
